// vanilla-modalについて： https://github.com/kayac/smout-issues/issues/104
import VanillaModal from 'vanilla-modal';

export default class Modal {
  /**
   * @param options
   * refs: https://github.com/pixelunion/vanilla-modal/tree/v1.6.6
   * hooks:
   *   ex: onBeforeOpen, onBeforeClose, onOpen, onClose
   */
  constructor(options = {}) {
    this.options = options;
    this.initialize();
  }

  initialize() {
    const defaults = {
      modalInner: '.modal-Inner',
      modalContent: '.modal-Content',
      onBeforeOpen() {
        // モーダルの横幅をコントロールする
        // #modal-idを指定している要素にdata-size属性をしていすることで、max-widthを指定できる
        // enum: ['xs', 'sm', 'md', 'lg'] 使う必要性がでてきたときに適宜追加。CSSも。
        this.dom.modalInner.classList.remove('modal-Inner-xs');
        this.dom.modalInner.classList.remove('modal-Inner-sm');
        this.dom.modalInner.classList.remove('modal-Inner-md');
        this.dom.modalInner.classList.remove('modal-Inner-inline');

        const size = this.current.getAttribute('data-size');
        const corner = this.current.getAttribute('data-corner');
        switch (size) {
          case 'md': {
            this.dom.modalInner.classList.add('modal-Inner-md');
            break;
          }
          case 'sm': {
            this.dom.modalInner.classList.add('modal-Inner-sm');
            break;
          }
          case 'xs': {
            this.dom.modalInner.classList.add('modal-Inner-xs');
            break;
          }
          case 'inline': {
            this.dom.modalInner.classList.add('modal-Inner-inline');
            break;
          }
          default: {
            this.dom.modalInner.classList.remove('modal-Inner-md');
            break;
          }
        }
        if (corner === 'rounded') {
          this.dom.modalInner.classList.add('modal-Inner-rounded');
        }
      },
    };
    this.instance = new VanillaModal({ ...defaults, ...this.options });
  }

  open(id) {
    this.instance.open(id);
  }

  close() {
    this.instance.close();
  }
}
